'use client';
import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type * as React from 'react';

import getQueryClient from '@/lib/get-query-client';

export default function ReactQueryClientContext({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/*<ReactQueryDevtools />*/}
    </QueryClientProvider>
  );
}
